import { Station } from 'src/app/core';
import { StationService } from '../core/services/station.service';
import { StationRequest } from '../shared/model/station-request.interface';
import { HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RemoteApiService } from '../core/services/remote-api.service';
import { StationSourceData } from '../shared/model/station-source-request';
import { StationSource } from '../core/models/station-source';

@Injectable({
  providedIn: 'root',
})
export class StationManagementService {

  public createEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  private readonly REGEXP = new RegExp(/:[^:]*$/, 'g');
  constructor(private remoteApi: RemoteApiService, private stationService: StationService) { }

  findIdStationsOnSIA(): Observable<string[]> {
    const parameters: any = {};
    return this.remoteApi
      .getIdsStationSIA<any>(
        '/configs?key=mediamonitor.api.iheart.stations',
        parameters
      )
      .pipe(
        map((resp: any) => {
          return resp.value
            .split(',')
            .map((value) => value.replace(this.REGEXP, ''));
        }),
        catchError(() => {
          return of([]);
        })
      );
  }

  getVeritoneMarkets(): Observable<any> {
    const parameters: any = {};
    return this.remoteApi.getMarketOnSIA<any>('/markets', parameters).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  getVeritoneStations(): Observable<any> {
    const parameters: any = {};
    return this.remoteApi.getMarketOnSIA<any>('/stations', parameters).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  saveStation(body: StationRequest): Observable<any> {
    if (body) {
      return this.remoteApi
        .postStation<any>(
          `/stations`,
          body,
          new HttpHeaders({
            'Content-Type': 'application/json',
          })
        )
        .pipe(
          map((resp: any) => true),
          catchError(() => {
            return of(false);
          })
        );
    } else {
      return of(false);
    }
  }

  updateStation(body: any): Observable<any> {
    return this.remoteApi
      .putStation<any>(
        `/update`,
        body,
        new HttpHeaders({
          'Content-Type': 'application/json',
        })
      )
      .pipe(
        map((resp: any) => resp),
        catchError(() => {
          return of(false);
        })
      );
  }

  deleteConfigStation(stationId: any): Observable<any> {
    return this.remoteApi.deleteTranscript<any>(`/stations/${stationId}`).pipe(
      map((resp: any) => true),
      catchError(() => {
        return of(false);
      })
    );
  }

  addSourceToStation(body: StationSourceData): Observable<Station> {

    return this.remoteApi.postStream<Station>('/station/source', body).pipe(
      map((resp: Station) => resp),
      catchError((erro) => {
        console.error(erro);
        return of(null);
      })
    );
  }

  deleteStation(stationId: any): Observable<any> {
    return this.remoteApi.deleteStream<any>(`/station/${stationId}`).pipe(
      map((resp: any) => true),
      catchError(() => {
        return of(false);
      })
    );
  }

  stationSourceList(): Observable<StationSource[]> {
    return this.stationService.stationSourceList().pipe(
      map((resp) => {

        return resp.filter((source) => source.id > 2);
      }));
  }

  createOrUpdateSource(body: StationSource): Observable<StationSource> {

    if (body.id) {
      return this.remoteApi.putStream<StationSource>(`/station-sources/${body.id}`, body).pipe(
        map((resp: StationSource) => resp),
        catchError((erro) => {
          console.error(erro);
          return of(null);
        })
      );
    } else {
      return this.remoteApi.postStream<StationSource>('/station-sources', body).pipe(
        map((resp: StationSource) => resp),
        catchError((erro) => {
          console.error(erro);
          return of(null);
        })
      );
    }

  }

  deleteStationSource(stationSourceId: number): Observable<StationSource> {

    return this.remoteApi.deleteStream<StationSource>(`/station-sources/${stationSourceId}`);
  }

}
